(() => {
  const configEl = document.getElementById('ka-bis-config');
  const dialog = document.getElementById('ka-bis-dialog');
  if (!configEl || !dialog) return;

  const form = dialog.querySelector('[data-ka-bis-form]');
  const emailInput = dialog.querySelector('[data-ka-bis-email]');
  const statusEl = dialog.querySelector('[data-ka-bis-status]');
  const submitBtn = dialog.querySelector('[data-ka-bis-submit]');
  const titleEl = dialog.querySelector('[data-ka-bis-product-title]');
  const closeEls = dialog.querySelectorAll('[data-ka-bis-close]');
  const stringsEl = document.getElementById('ka-bis-strings');
  const strings = JSON.parse(configEl.textContent);
  if (stringsEl) {
    stringsEl.querySelectorAll('[data-key]').forEach((node) => {
      strings[node.dataset.key] = node.textContent.trim();
    });
  }

  const getCompanyId = () => {
    if (strings.companyId) return strings.companyId;

    const scripts = document.querySelectorAll('script[src], script:not([src])');
    for (const script of scripts) {
      const haystack = `${script.src || ''} ${script.textContent || ''}`;
      const match = haystack.match(/company_id=([A-Za-z0-9]+)/i) || haystack.match(/["']company_id["']\s*:\s*["']([A-Za-z0-9]+)["']/i);
      if (match) return match[1];
    }

    return '';
  };

  const getVariantId = (trigger) => {
    if (trigger.dataset.kaBisVariantId) return trigger.dataset.kaBisVariantId;
    const root = trigger.closest('product-info') || document;
    const input = root.querySelector('input.product-variant-id, form[data-type="add-to-cart-form"] input[name="id"]');
    return input?.value || strings.variantId || '';
  };

  const getProductTitle = (trigger) => {
    if (trigger.dataset.kaBisProductTitle) return trigger.dataset.kaBisProductTitle;
    const root = trigger.closest('product-info') || document;
    const heading = root.querySelector('.product__title h1, .product__title .h1');
    return heading?.textContent?.trim() || strings.productTitle || '';
  };

  const setStatus = (message, type) => {
    if (!statusEl) return;
    statusEl.hidden = !message;
    statusEl.textContent = message || '';
    statusEl.dataset.state = type || '';
  };

  const openDialog = (trigger) => {
    dialog.dataset.variantId = getVariantId(trigger);
    if (titleEl) titleEl.textContent = getProductTitle(trigger);
    setStatus('', '');
    if (form) form.hidden = false;
    if (submitBtn) submitBtn.disabled = false;
    if (strings.customerEmail && emailInput) emailInput.value = strings.customerEmail;
    dialog.hidden = false;
    document.body.classList.add('ka-bis-open');
    emailInput?.focus();
  };

  const closeDialog = () => {
    dialog.hidden = true;
    document.body.classList.remove('ka-bis-open');
  };

  const subscribe = async (email, variantId) => {
    const companyId = getCompanyId();
    if (!companyId) {
      throw new Error(strings.missingKey);
    }
    if (!variantId) {
      throw new Error(strings.genericError);
    }

    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: '2024-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        }),
      }
    );

    if (!response.ok && response.status !== 202) {
      let detail = strings.genericError;
      try {
        const payload = await response.json();
        detail = payload?.errors?.[0]?.detail || detail;
      } catch (error) {
        /* keep fallback */
      }
      throw new Error(detail);
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ka-bis-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openDialog(trigger);
  });

  closeEls.forEach((el) => el.addEventListener('click', closeDialog));

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !dialog.hidden) closeDialog();
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const email = emailInput?.value.trim();
    const variantId = dialog.dataset.variantId;
    if (!email) {
      setStatus(strings.invalidEmail, 'error');
      emailInput?.focus();
      return;
    }

    submitBtn.disabled = true;
    setStatus(strings.submitting, '');

    try {
      await subscribe(email, variantId);
      setStatus(strings.success, 'success');
      form.hidden = true;
    } catch (error) {
      setStatus(error.message || strings.genericError, 'error');
      submitBtn.disabled = false;
    }
  });
})();
